import React from "react";
import {
  useTranslate,
} from "@refinedev/core";
import {
  Typography,
  Stack,
  Paper,
} from "@mui/material";
import { CompanyFormSchema } from "@/utils/zod/companyFormValidation";
import { ShowField } from "../show/Field";

interface CompanyShowContentProps {
  company: CompanyFormSchema;
}

export const CompanyShowContent: React.FC<CompanyShowContentProps> = ({ company }) => {
  const t = useTranslate();

  return (
    <Stack spacing="32px" padding="32px 32px 56px 32px">

      {/* Company Info */}
      <Stack spacing="24px">
        <Typography variant="h5">{company.ledger_name}</Typography>

        <Paper>
          {/* Ledger Name */}
          <ShowField title={t("company.fields.ledger_name")} value={company.ledger_name} />

          {/* Legal Name */}
          <ShowField title={t("company.fields.legal_name")} value={company.legal_name || ""} />

          {/* GSTIN */}
          <ShowField title={t("company.fields.gstin")} value={company.gstin || ""} />

          {/* PAN Number */}
          <ShowField title={t("company.fields.pan_number")} value={company.pan_number || ""} />

          {/* Email */}
          <ShowField title={t("company.fields.email")} value={company.email || ""} />

          {/* Members */}
          <ShowField title={t("company.fields.members")} value={company.accounts?.map((account) => `${(account.name && account.user?.name) ? `${account.name} (${account.user?.name})` : account.name ? account.name : account.user?.name ? `(${account.user?.name})` : ""}: ${account.user?.phone_number}` || "") || []} />

          {/* Tags */}
          <ShowField title={t("company.fields.tags")} value={company.tags ?? []} />

          {/* Type */}
          <ShowField title={t("company.fields.type")} value={company.type || ""} />
          </Paper>

          <Paper>
            {/* Send Outstanding to */}
            <ShowField title={t("company.fields.send_outstanding_to")} value={company.send_outstanding_to_accounts?.map((account) => `${(typeof account !== "string") && (account.name && account.user?.name) ? `${account.name} (${account.user?.name})` : (typeof account !== "string") && account.name ? account.name : (typeof account !== "string") && account.user?.name ? `(${account.user?.name})` : ""}: ${(typeof account !== "string") && account.user?.phone_number}` || "") || []} />
          </Paper>


          <Typography variant="h6" marginBlock="24px">{t("company.fields.addresses")}</Typography>
          {company.addresses?.map((address, index) => (
            <Paper>
              <Typography variant="h6" paddingLeft="24px">{`${t("company.fields.address")} ${index + 1}`}</Typography>
              {/* Branch */}
              <ShowField title={t("company.fields.branch_name")} value={address?.branch_name || ""} />

              {/* Landline Number */}
              <ShowField title={t("company.fields.landline_number")} value={address?.landline_number || ""} />

              {/* GSTIN */}
              <ShowField title={t("company.fields.gstin")} value={address?.gstin || ""} />

              {/* Address */}
              <ShowField title={t("company.fields.address")} value={address?.line1 || ""} />

              {/* City */}
              <ShowField title={t("company.fields.city")} value={address?.city || ""} />

              {/* Pincode */}
              <ShowField title={t("company.fields.pincode")} value={address?.pincode || ""} />

              {/* State */}
              <ShowField title={t("company.fields.state")} value={address?.state || ""} />

              {/* Country */}
              <ShowField title={t("company.fields.country")} value={address?.country || ""} />

              {/* Transport Name */}
              <ShowField title={t("company.fields.transport_name")} value={address?.transport_name || ""} />

              {/* Transport Delivery Station */}
              <ShowField title={t("company.fields.transport_delivery_station")} value={address?.transport_delivery_station || ""} />
            </Paper>
          ))}


          <Paper>
          {/* Created At */}
          <ShowField title={t("company.fields.createdAt")} value={company.inserted_at?.toString() || ""} chipType="date" />
        </Paper>
      </Stack>
    </Stack>
  );
};